.mvRangeSliderWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
}

.mvRangeSliderLabel {
    font-size: 1rem;
    font-weight: 600;
}

.mvRangeSliderTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0.5rem 0 0.75rem 0;
}

.mvRangeSliderInputs {
    display: flex;
    align-items: center;

    span {
        margin: 0 0.35rem;
    }

    input {
        max-width: 80px;
        font-size: 1.1rem;
    }
}
